import { render, staticRenderFns } from "./TourForm.vue?vue&type=template&id=baae2a40&scoped=true"
import script from "./TourForm.vue?vue&type=script&lang=js"
export * from "./TourForm.vue?vue&type=script&lang=js"
import style0 from "./TourForm.vue?vue&type=style&index=0&id=baae2a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baae2a40",
  null
  
)

export default component.exports